module.exports = __webpack_public_path__ + "static/media/coquimbo.0e48cc76.jpg";